var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniPos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #b5b5c3;\n      }\n\n      .st1 {\n        fill: none;\n        stroke: #b5b5c3;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 16.64px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g4861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4869",
    className: "st1",
    d: "M576.81,539.34H61.08c-9.82,0-17.78-7.96-17.78-17.78v-71.13c0-9.82,7.96-17.78,17.78-17.78h515.73c9.82,0,17.78,7.96,17.78,17.78v71.13c0,9.82-7.96,17.78-17.78,17.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4871"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4873",
    className: "st1",
    d: "M398.98,112.53H78.87c-9.82,0-17.78,7.96-17.78,17.78v248.97c0,9.82,7.96,17.78,17.78,17.78h320.11c9.82,0,17.78-7.96,17.78-17.78v-248.97c0-9.82-7.96-17.78-17.78-17.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4877",
    className: "st1",
    d: "M434.54,432.63v106.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4881",
    className: "st1",
    d: "M78.87,468.2h320.11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4885",
    className: "st1",
    d: "M434.54,503.77h160.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4887"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4889",
    className: "st1",
    d: "M567.92,432.63v-35.57h-106.7v35.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4893",
    className: "st1",
    d: "M167.79,397.07v35.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4897",
    className: "st1",
    d: "M310.06,397.07v35.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4901",
    className: "st1",
    d: "M161.61,352.61h-64.96v-204.51h267.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4905",
    className: "st1",
    d: "M363.41,148.09h17.79v204.51h-231.18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4909",
    className: "st1",
    d: "M416.76,174.77h35.57c4.91,0,8.89,3.98,8.89,8.89v142.27c0,4.91-3.98,8.89-8.89,8.89h-35.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4921",
    className: "st1",
    d: "M69.98,548.23h17.78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4925",
    className: "st1",
    d: "M550.14,548.23h17.78"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.41,224.61c0-1.01.2-1.96.6-2.83.4-.87.94-1.62,1.63-2.25.68-.62,1.49-1.11,2.41-1.47.92-.35,1.91-.53,2.97-.53l24.45.04c3.94,0,7.4.48,10.37,1.45,2.97.97,5.45,2.38,7.43,4.25,1.98,1.86,3.47,4.14,4.46,6.83.99,2.69,1.49,5.75,1.49,9.17s-.5,6.41-1.49,9.04c-.99,2.63-2.48,4.84-4.46,6.62-1.98,1.78-4.46,3.13-7.43,4.03-2.97.91-6.43,1.34-10.37,1.29h-16.85v20.1c0,1.04-.2,1.99-.6,2.85-.4.86-.94,1.61-1.63,2.25-.68.64-1.49,1.13-2.41,1.49-.92.35-1.91.53-2.97.53s-2.05-.18-2.97-.53c-.92-.35-1.72-.85-2.41-1.49-.68-.64-1.23-1.39-1.63-2.25-.4-.86-.6-1.81-.6-2.85v-55.74ZM172.43,248.33c1.98.05,3.7-.14,5.17-.57,1.46-.42,2.67-1.03,3.61-1.82.94-.79,1.65-1.75,2.11-2.88.46-1.13.69-2.39.69-3.79s-.23-2.62-.69-3.75c-.46-1.13-1.16-2.11-2.11-2.92-.94-.81-2.15-1.44-3.61-1.88-1.46-.44-3.19-.65-5.17-.65h-13.8v18.26h13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.02,252.18c0-3.14.32-6.21.97-9.22s1.62-5.85,2.9-8.53c1.29-2.68,2.9-5.14,4.85-7.4,1.95-2.25,4.22-4.2,6.83-5.84,2.61-1.64,5.53-2.91,8.78-3.82,3.24-.91,6.82-1.36,10.74-1.36s7.55.45,10.83,1.36c3.28.91,6.23,2.18,8.85,3.82,2.62,1.64,4.91,3.59,6.88,5.84,1.97,2.25,3.61,4.72,4.92,7.4,1.31,2.68,2.29,5.52,2.94,8.53.65,3.01.97,6.08.97,9.22s-.32,6.21-.97,9.2c-.65,3-1.63,5.82-2.94,8.48-1.31,2.65-2.95,5.09-4.92,7.31-1.97,2.22-4.26,4.14-6.88,5.75-2.62,1.62-5.57,2.87-8.85,3.77-3.28.9-6.89,1.34-10.83,1.34s-7.5-.45-10.74-1.34c-3.24-.9-6.17-2.15-8.78-3.77-2.61-1.62-4.88-3.53-6.83-5.75-1.95-2.22-3.56-4.65-4.85-7.31-1.29-2.65-2.25-5.48-2.9-8.48-.65-3-.97-6.06-.97-9.2ZM220.38,252.18c0,1.89.16,3.76.48,5.63.32,1.86.82,3.65,1.5,5.34.68,1.7,1.55,3.28,2.6,4.74s2.31,2.73,3.77,3.79,3.14,1.9,5.03,2.51c1.89.61,4,.92,6.33.92s4.54-.31,6.46-.92c1.92-.61,3.63-1.45,5.11-2.51s2.76-2.32,3.82-3.79c1.06-1.46,1.93-3.04,2.62-4.74.68-1.7,1.19-3.48,1.5-5.34.32-1.86.48-3.74.48-5.63s-.16-3.77-.48-5.65c-.32-1.88-.82-3.67-1.5-5.4-.68-1.72-1.56-3.31-2.62-4.78-1.06-1.46-2.34-2.74-3.82-3.82-1.49-1.08-3.19-1.93-5.11-2.55-1.92-.61-4.08-.92-6.46-.92s-4.45.31-6.33.92c-1.89.61-3.56,1.46-5.03,2.55-1.46,1.09-2.72,2.36-3.77,3.82s-1.92,3.06-2.6,4.78c-.68,1.72-1.19,3.52-1.5,5.4-.32,1.88-.48,3.76-.48,5.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.15,266.69c1.42,2.78,3.35,4.95,5.8,6.51,2.45,1.56,5.41,2.34,8.88,2.34.92,0,1.91-.03,2.96-.09,1.05-.06,2.09-.19,3.12-.39,1.03-.2,2.01-.48,2.96-.83.94-.35,1.77-.83,2.5-1.42.72-.59,1.3-1.31,1.73-2.18s.66-1.88.66-3.06-.27-2.28-.81-3.17-1.29-1.65-2.25-2.3c-.96-.65-2.09-1.2-3.4-1.65-1.31-.45-2.73-.87-4.26-1.26-1.53-.39-3.14-.76-4.83-1.11-1.69-.35-3.39-.75-5.11-1.2-2.64-.71-5.19-1.55-7.64-2.53-2.45-.98-4.62-2.23-6.49-3.77-1.88-1.53-3.37-3.42-4.49-5.64-1.12-2.23-1.68-4.96-1.68-8.19,0-2.36.35-4.52,1.06-6.48.71-1.96,1.69-3.72,2.94-5.27,1.25-1.56,2.72-2.92,4.41-4.09,1.69-1.17,3.51-2.14,5.47-2.9,1.96-.77,4-1.34,6.14-1.72,2.13-.38,4.26-.57,6.39-.57,2.88,0,5.65.27,8.32.8s5.13,1.36,7.38,2.48,4.25,2.54,5.98,4.25c1.73,1.71,3.1,3.73,4.09,6.07.19.47.34.96.46,1.45.12.5.18,1.01.18,1.56,0,1.04-.17,1.99-.5,2.87-.33.87-.8,1.63-1.4,2.27-.6.64-1.33,1.13-2.18,1.49-.85.35-1.79.53-2.83.53-.83,0-1.62-.12-2.37-.37s-1.45-.58-2.09-1.01-1.2-.94-1.7-1.54c-.5-.6-.92-1.26-1.27-1.96-1.04-2.1-2.63-3.64-4.78-4.62-2.15-.98-4.73-1.47-7.75-1.47-1.27,0-2.55.13-3.84.39-1.29.26-2.45.68-3.49,1.26-1.04.58-1.89,1.32-2.55,2.21s-.99,1.98-.99,3.26c0,.87.1,1.64.3,2.3.2.66.58,1.26,1.13,1.8.55.54,1.31,1.05,2.27,1.52.96.47,2.2.96,3.73,1.47,1.53.51,3.39,1.06,5.56,1.65,2.17.59,4.73,1.26,7.68,2.02.87.21,1.98.48,3.33.81,1.34.33,2.77.79,4.26,1.38,1.5.59,3.01,1.34,4.53,2.27,1.52.92,2.89,2.08,4.11,3.47s2.2,3.06,2.96,5.01c.75,1.95,1.13,4.23,1.13,6.85,0,3.21-.64,6.18-1.91,8.9s-3.16,5.08-5.64,7.06c-2.49,1.98-5.57,3.53-9.25,4.65-3.68,1.12-7.93,1.68-12.74,1.68-3.11,0-6.14-.35-9.08-1.04s-5.65-1.73-8.12-3.11c-2.48-1.38-4.67-3.1-6.56-5.17-1.9-2.06-3.37-4.45-4.41-7.17-.19-.47-.34-.96-.46-1.45-.12-.5-.18-1.01-.18-1.56,0-1.04.18-1.99.55-2.87.37-.87.88-1.63,1.54-2.26.66-.64,1.43-1.13,2.32-1.49.88-.35,1.85-.53,2.88-.53,1.68,0,3.15.46,4.42,1.38,1.27.92,2.27,2.09,2.97,3.5Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniPos);
export default __webpack_public_path__ + "static/media/mini-pos.846aa9ded6a01298d66236120cf34bb9.svg";
export { ForwardRef as ReactComponent };